import { useEffect, useState } from "react";
import SplitListPreview from "./SplitListPreview";

function normalizeCourseDescription(description) {
  if (!description) return "";
  if (Array.isArray(description)) return description[0] || "";
  if (typeof description === "string") {
    try {
      const parsed = JSON.parse(description);
      if (Array.isArray(parsed)) return parsed[0] || "";
    } catch {
      return description;
    }
    return description;
  }
  return String(description);
}

function normalizeAssetUrl(value) {
  if (!value) return "";
  const str = String(value).trim();
  if (!str) return "";
  if (/^https?:\/\//i.test(str) || str.startsWith("data:")) return str;
  return str.startsWith("/") ? str : `/${str}`;
}

function extractYoutubeId(url = "") {
  if (!url) return "";
  const match = String(url).match(
    /(?:youtu\.be\/|youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/))([^?&/]+)/i
  );
  return match ? match[1] : "";
}

function youtubeThumb(url) {
  const id = extractYoutubeId(url);
  return id ? `https://img.youtube.com/vi/${id}/hqdefault.jpg` : "";
}

function resolveCoursePreviewImage(course = {}) {
  const explicitImage =
    course.image ||
    course.cover ||
    course.thumbnail ||
    course.previewImage ||
    course.heroImage ||
    course.banner;

  if (explicitImage) return normalizeAssetUrl(explicitImage);

  const videoImage =
    youtubeThumb(course.videoUrl) ||
    youtubeThumb(course.video_url) ||
    youtubeThumb(course.youtubeUrl) ||
    youtubeThumb(course.youtube_url);

  if (videoImage) return videoImage;
  return "/images/b_gray-full.svg";
}

export default function CourseHeroList() {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let mounted = true;
    fetch("https://www.denisbitter.de/stage01/api/get_courses.php")
      .then((res) => res.json())
      .then((json) => {
        if (!mounted) return;
        if (!json?.success || !Array.isArray(json?.data)) {
          throw new Error("Ungültige Kursdaten");
        }
        const favoriteCourses = json.data.filter((course) => String(course.isFavorite) === "1");
        setCourses(favoriteCourses);
      })
      .catch((err) => {
        console.error("Course Fetch Error:", err);
        if (!mounted) return;
        setError("Kurse konnten nicht geladen werden.");
      })
      .finally(() => {
        if (!mounted) return;
        setLoading(false);
      });

    return () => {
      mounted = false;
    };
  }, []);

  return (
    <div className="p-3 sm:p-6 max-w-6xl pt-6 sm:pt-14 pb-8 sm:pb-10 mx-auto">
      <SplitListPreview
        label="Kurse"
        command="ls kurse/"
        loading={loading}
        error={error}
        introKicker="Lernpfade"
        introHeadline="Kurse mit Struktur, Praxis und klaren Projektergebnissen."
        hideCommand
        showDesktopPreview={false}
        items={courses.map((course) => ({
          id: `course-${course.slug || course.id}`,
          title: course.title,
          subtitle: normalizeCourseDescription(course.description) || "Praxiskurs",
          meta: course.platform || "Kurs",
          date: course.date || "",
          image: resolveCoursePreviewImage(course),
          href: `/course/${course.slug || course.id}`,
          external: false,
        }))}
      />
    </div>
  );
}
